import { FETCH_VENDORS, CREATE_INVOICE, FETCH_BOXES, FETCH_INVOICE, FETCH_INVOICES } from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_VENDORS
// --------------------------------------------------------------------------
export const fetchVendors = () => ({
  type: FETCH_VENDORS.init,
  payload: API.fetchVendors(),
});

export const fetchVendorsSuccess = (info) => ({
  type: FETCH_VENDORS.success,
  payload: info,
});

export const fetchVendorsFailure = (error) => ({
  type: FETCH_VENDORS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// CREATE_INVOICE
// --------------------------------------------------------------------------
export const createInvoice = (data) => ({
  type: CREATE_INVOICE.init,
  payload: API.createInvoice(data),
});

export const createInvoiceSuccess = (info) => ({
  type: CREATE_INVOICE.success,
  payload: info,
});

export const createInvoiceFailure = (error) => ({
  type: CREATE_INVOICE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_BOXES
// --------------------------------------------------------------------------
export const fetchBoxes = (iId) => ({
  type: FETCH_BOXES.init,
  payload: API.fetchBoxes(iId),
});

export const fetchBoxesSuccess = (info) => ({
  type: FETCH_BOXES.success,
  payload: info,
});

export const fetchBoxesFailure = (error) => ({
  type: FETCH_BOXES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVOICE
// --------------------------------------------------------------------------
export const fetchInvoice = (iId) => ({
  type: FETCH_INVOICE.init,
  payload: API.fetchInvoice(iId),
});

export const fetchInvoiceSuccess = (info) => ({
  type: FETCH_INVOICE.success,
  payload: info,
});

export const fetchInvoiceFailure = (error) => ({
  type: FETCH_INVOICE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVOICES
// --------------------------------------------------------------------------
export const fetchInvoices = (page, invoiceNumber, invoiceDate, invoiceVendor) => ({
  type: FETCH_INVOICES.init,
  payload: API.fetchInvoices(page, invoiceNumber, invoiceDate, invoiceVendor),
});

export const fetchInvoicesSuccess = (info) => ({
  type: FETCH_INVOICES.success,
  payload: info,
});

export const fetchInvoicesFailure = (error) => ({
  type: FETCH_INVOICES.failure,
  payload: error,
});
